<h2><span i18n="@@titleStatus">Status</span>&nbsp;<span i18n="@@Charger">Charger</span> {{ chargerId }}</h2>

@let chargerOverviewData = chargerOverview();
@if (chargerOverviewLoaded() && (chargerOverviewData)) {
	<div class="card-container">
		<mat-card class="mat-elevation-z5 charger-card">
			<mat-card-content>
				<div class="status">{{ chargerOverviewData.chargerStatus.indicators.chargingState | chargingStateTranslate }}</div>

				<div class="circle-wrapper">
					<div class="charging-circle"
						[ngClass]="{
							'charging-circle-standby':   chargerOverviewData.chargerStatus.indicators.chargingState === 'Standby',
							'charging-circle-connected': chargerOverviewData.chargerStatus.indicators.chargingState === 'VehicleDetected',
							'charging-circle-charging':  chargerOverviewData.chargerStatus.indicators.chargingState === 'Charging',
							'charging-circle-error':     chargerOverviewData.chargerStatus.indicators.chargingState === 'Error'
						}"
					></div>
					<div class="circle-text"
						[ngClass]="{
							'text-error': chargerOverviewData.chargerStatus.indicators.chargingState === 'Error'
						}"
					>
						@if (chargerOverviewData.chargerStatus.indicators.chargingState === "Charging") {
							<div class="label" i18n="@@ActualChargingPower">Actual Charging Power</div>
							<div class="value">{{ (chargerOverviewData.chargeSessionStatus.actualChargingPower / 1000) | number:'1.1-1' }} kW</div>
						}
						@else if (chargerOverviewData.chargerStatus.indicators.chargingState === "Error") {
							@let error = getError(chargerOverviewData.chargerStatus.indicators.errors[0].errorCode);
							<div class="value">{{ error.number }}</div>
							<div class="label">{{ error.description }}</div>
						}
					</div>
				</div>

				@if (chargerOverviewData.chargerStatus.isChargeStartAllowed) {
					<button class="start-btn" (click)="startCharge()" i18n="@@Start">Start</button>
				} @else if (chargerOverviewData.chargerStatus.isChargeStopAllowed) {
					<button class="start-btn" (click)="stopCharge()" i18n="@@Stop">Stop</button>
				} @else {
					<button class="start-btn" disabled i18n="@@Start">Start</button>
				}
			</mat-card-content>
		</mat-card>
	</div>
} @else {
	<mat-spinner />
}
